import { Metric_DataPoint } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/metrics_pb';
import { getSensorValue } from '~/shared/models/metrics/metrics-utils';

export function roundToDecimals(number: number, decimals: number) {
  const factor = 10 ** decimals;
  return Math.round(number * factor) / factor;
}

export function litersToCubicMeters(liters: number) {
  return liters / 1000;
}

export function getRoundedUsage(metricDataPoint: Metric_DataPoint) {
  return roundToDecimals(
    litersToCubicMeters(getSensorValue(metricDataPoint)),
    0,
  );
}

export function getRoundedKpiValue(value: number) {
  return roundToDecimals(litersToCubicMeters(value), 0);
}
